module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/core/components/widget/widget.component.html
// module id = ../../../../../src/app/core/components/widget/widget.component.html
// module chunks = main